const baseURL = import.meta.env.VITE_APP_API_BASE_URL

const API = {
	TOKEN: {
		ACCESS: `api/token/`,
		REFRESH: `api/token/refresh/`
	},
	APPLICATION: {
		BASE: `applications/`
	},
	DOCUMENT: {
		BASE: `documents/`,
		UPLOAD: `documents/upload/`,
		DOWNLOAD: (id: number) => `documents/${id}/download/`
	},
	VALIDATION: {
		BASE: `validations/`
	},
	FAIRLEAD: {
		BASE: `fairleads/`
	},
	SHIP: {
		BASE: `ships/`,
		IMPORT: `ships/import/`,
		UPLOAD: `ships/upload/`,
		TEMPLATE: `ships/download_template/`,
		EXCEL_EXPORT: (id: number) => `ships/${id}/export/`,
		AUTOCAD_EXPORT: (id: number) => `ships/${id}/autocad_export/`,
		PAGINATE: `ships_pagination/`
	},
	SHIP_TYPE: {
		BASE: `ship_types/`
	},
	USER: {
		BASE: `users/`,
		CURRENT_USER: `users/current_user/`
	}
}

export default API
